import type { TextI } from "tweenly"
import { t } from "i18next"
import Filters from "./ExpandableSections/Filters"
import MarginAndPadding from "./ExpandableSections/MarginAndPadding"
import Appearance from "./ExpandableSections/Appearance"
import SizeAndPosition from "./ExpandableSections/SizeAndPosition"
import TextAndFont from "./ExpandableSections/TextAndFont"
import TextColor from "./ExpandableSections/TextColor"
import Transforms from "./ExpandableSections/Transforms"

interface Props {
    object: TextI
    handleSetStyleValue: (property: any, value: any) => void
    handleSetObjectValue: (property: any, value: any) => void
    handleSetAttributeValue: (property: any, value: any) => void
}

const TextTools = ({
    object,
    handleSetStyleValue,
    handleSetObjectValue,
    handleSetAttributeValue,
}: Props) => {
    return (
        <div>
            <SizeAndPosition object={object} handleSetValue={handleSetStyleValue} />
            <Appearance object={object} handleSetValue={handleSetStyleValue} />

            <TextAndFont
                object={object}
                handleSetValue={handleSetObjectValue}
                handleSetStyleValue={handleSetStyleValue}
                handleSetAttributeValue={handleSetAttributeValue}
            />

            <MarginAndPadding object={object} handleSetValue={handleSetStyleValue} />

            <TextColor
                title={t("editor:colorTool.textTitle")}
                object={object}
                handleSetValue={handleSetStyleValue}
            />

            <Filters object={object} handleSetObjectValue={handleSetObjectValue} />

            <Transforms
                object={object}
                handleSetStyleValue={handleSetStyleValue}
                handleSetObjectValue={handleSetObjectValue}
            />
        </div>
    )
}

export default TextTools
